import { Dialog } from "@mui/material";
import { useState } from "react";
import ConfirmDialog from "./confirmDialog";

const CustomDialog = ({
    onClose,
    dismissible = false,
    needConfirm = false,
    confirmDialogProps = {
        handleClose: () => { },
        title: "Cerrar Ventana",
        warningText: "",
        loading: false,
        text: "¿Está seguro que desea cerrar esta ventana? Los cambios no guardados se perderán.",
        cancelText: "Cancelar",
        confirmText: "Aceptar",
    },
    ...props
}) => {

    const [openConfirm, setOpenConfirm] = useState(false);

    const handleClose = (event, reason) => {
        if (dismissible) {
            if (onClose) {
                onClose(event, reason);
            }
            return;
        }

        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            if (needConfirm) {
                setOpenConfirm(true);
                return;
            }
            return;
        }

        if (onClose) {
            onClose(event, reason);
        }
    };

    const handleConfirmClose = () => {
        setOpenConfirm(false);
        if (onClose) {
            onClose();
        }
    };

    const handleCancelClose = () => {
        setOpenConfirm(false);
    };

    return (
        <>
            <Dialog
                {...props}
                onClose={handleClose}
            >
                {props.children}
            </Dialog>

            {needConfirm && <ConfirmDialog
                open={openConfirm}
                handleCancelClose={confirmDialogProps.handleClose}
                handleClose={handleCancelClose}
                handleConfirm={handleConfirmClose}
                title={confirmDialogProps.title}
                text={confirmDialogProps.text}
                warningText={confirmDialogProps.warningText}
                cancelText={confirmDialogProps.cancelText}
                confirmText={confirmDialogProps.confirmText}
                loading={confirmDialogProps.loading}
            />}
        </>
    );
};

export default CustomDialog;